export default "__VITE_ASSET__UT8DFapf__"